import { graphql } from "@/gql";

export const generateStatementOfAccounts = graphql(`
  mutation GenerateStatementOfAccounts(
    $input: GenerateStatementOfAccountsInput!
  ) {
    generateStatementOfAccounts(input: $input)
  }
`);
